import { portalApi } from "@services/api/portalApi"

export type ParentStudent = {
    firstName: string;
    surname: string;
    studentNo: number;
}

export type Parent = {
    idParent: number;
    parentFirstName: string;
    parentSurname: string;
    parentEmail: string;
    students: ParentStudent[];
}

export async function getParents(): Promise<Parent[]> {
    try {
        const response = await portalApi.get<Parent[]>('/parents', {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        return response.data
    } catch (error) {
        console.error('Error fetching parents', error)
        throw new Error('Failed to fetch parents')
    }
}
